





































































import { Component, Vue } from 'vue-property-decorator';
import UserIcon from 'mdi-vue/AccountSearch';
import AddIcon from 'mdi-vue/Plus';
import CheckIcon from 'mdi-vue/Check';
import CloseIcon from 'mdi-vue/Close';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import api from '@/libs/api';
import Modal from '@/components/Modal.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import numberFormat from '@/libs/numberFormat';
import FormInput from '@/components/FormInput.vue';
import { InvoiceSMSResponse, User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    Modal,
    FormInput,
    LayoutTitle,
    LayoutContent,
    TagInput,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchField,
    SearchRow,
    Select,
    TableBody,
    ScrollbarWrapper,
    UserIcon,
    AddIcon,
    CheckIcon,
    CloseIcon,
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class SMSEditor extends Vue {
  user!: {
    user: User;
  };

  merchantId = '';

  loadingSubmit = false;
  loading = true;

  ip = '';
  username = '';
  password = '';

  async submit() {
    try {
      this.loadingSubmit = true;

      /* eslint-disable @typescript-eslint/camelcase */
      const formData = new FormData();
      formData.append('merch_id', this.merchantId);
      formData.append('sms_username', this.username);
      formData.append('sms_password', this.password);
      formData.append('ipaddress', this.ip);
      formData.append('sub', 'submit');
      const { data } = await api.post('/easyinvoice/merchantconfigs_sms', formData);
      /* eslint-enable @typescript-eslint/camelcase */

      if (data.status === '00') {
        showToast(ToastType.SUCCESS, 'Success', data.message);
      } else {
        showToast(ToastType.FAILED, data.case, data.message.join(', '));
      }

      this.loadingSubmit = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getDetail() {
    try {
      this.loading = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get<InvoiceSMSResponse>('/easyinvoice/merchantconfigs_sms_detail');
      this.username = data.sms_username;
      this.password = data.sms_passwd;
      this.ip = data.ip_address;
      this.merchantId = data.mid;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async mounted() {
    await this.getDetail();
  }
}
